import { useMemo } from 'react';

const CUSTOM_THEME_COLORS = ['buttonColor', 'buttonTextColor'] as const;

type CustomThemeColors = (typeof CUSTOM_THEME_COLORS)[number];

type ParsedColors = {
  [key in CustomThemeColors]: string | undefined;
};

type CustomTheme = ParsedColors & {
  isPresent: boolean;
};

export const useCustomTheme = (): CustomTheme => {
  const colors = useMemo(() => {
    const queryParams = new URLSearchParams(window.location.search);
    return CUSTOM_THEME_COLORS.reduce(
      (prev, cur) => ({ ...prev, [cur]: queryParams.get(cur) || undefined }),
      {} as ParsedColors
    );
  }, []);

  return {
    ...colors,
    isPresent: Object.values(colors).some((color) => color !== undefined),
  };
};
